export default "__VITE_ASSET__BeynnUle__"